
export default function Index() {
  return (
    <div>Hello World</div>
  );
}
